import './Avatar.scss';
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { User } from '../../models/User';

type Props = {
  size?: string;
  user?: User;
  letters?: string;
}

export default function Avatar({ size = 'md', user, letters }: Props) {
  const initials = letters
    ? letters.substring(0, 3)
    : (user && user.given_name && user.family_name)
      ? user.given_name.charAt(0) + user.family_name.charAt(0)
      : null;

  return <div className={`avatar ${size}`}>{initials || <FontAwesomeIcon icon={solid('user')} />}</div>
}